import React from "react";
import { useAccount, useConnect, useDisconnect } from "wagmi";
import { LOGO_URL, shortAddr } from "./Brand";

export default function Navbar() {
  const { address, isConnected, chain } = useAccount();
  const { connectors, connect, isPending } = useConnect();
  const { disconnect } = useDisconnect();

  const wrongChain = isConnected && chain && chain.id !== 56;

  return (
    <nav className="relative z-10 w-full px-6 md:px-10 py-5 flex items-center justify-between">
      <a href="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
        <div className="relative">
          <img
            src={LOGO_URL}
            alt="LuckyZongzi"
            className="w-12 h-12 md:w-14 md:h-14 rounded-full"
            style={{ boxShadow: "0 0 0 2px rgba(243,186,47,0.5), 0 0 24px rgba(243,186,47,0.25)" }}
          />
          <span className="absolute -inset-2 rounded-full opacity-0 group-hover:opacity-100 transition"
                style={{ background: "radial-gradient(circle, rgba(243,186,47,0.3), transparent 60%)" }} />
        </div>
        <div className="leading-tight">
          <div className="font-display font-bold text-xl md:text-2xl gold-shimmer">幸运粽子</div>
          <div className="font-num text-[10px] md:text-xs tracking-[0.25em] text-emerald-200/70">LUCKY ZONGZI</div>
        </div>
      </a>

      <div className="hidden md:flex items-center gap-7 text-sm text-emerald-100/80">
        <a href="#hero" className="hover:text-amber-300 transition" data-testid="nav-link-home">首页</a>
        <a href="#slot" className="hover:text-amber-300 transition" data-testid="nav-link-draw">抽奖</a>
        <a href="#winners" className="hover:text-amber-300 transition" data-testid="nav-link-winners">中奖榜</a>
        <a href="#about" className="hover:text-amber-300 transition" data-testid="nav-link-about">关于</a>
      </div>

      <div className="flex items-center gap-3">
        <a
          href="https://x.com/LUCKYZONGZI"
          target="_blank"
          rel="noreferrer"
          data-testid="navbar-x-link"
          className="glass gold-border w-10 h-10 flex items-center justify-center hover:bg-emerald-900/40 transition group"
          title="Follow @LUCKYZONGZI on X"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-amber-300 group-hover:fill-white transition">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z"/>
          </svg>
        </a>
        {wrongChain && (
          <span className="hidden md:inline text-xs text-amber-300/90 border border-amber-300/30 px-2 py-1 rounded">
            请切换至 BSC 主网
          </span>
        )}
        {isConnected ? (
          <button
            data-testid="navbar-disconnect"
            onClick={() => disconnect()}
            className="glass gold-border px-4 py-2 flex items-center gap-2 text-sm hover:bg-emerald-900/40 transition"
          >
            <span className="pulse-dot" />
            <span className="addr">{shortAddr(address)}</span>
          </button>
        ) : (
          <button
            data-testid="navbar-connect"
            disabled={isPending}
            onClick={() => {
              const injected = connectors.find((c) => c.id === "injected") || connectors[0];
              if (injected) connect({ connector: injected });
            }}
            className="btn-ribbon text-sm"
          >
            {isPending ? "连接中…" : "连接钱包"}
          </button>
        )}
      </div>
    </nav>
  );
}
